export enum CampaignStatusEnum {
  Disabled = 0,
  Enabled = 1,
  Paused = 2,
}
